import type { CompanyApiOrganization } from '@/types/Organization'

// Mock organization data for testing
const mockOrgData: CompanyApiOrganization[] = [
  {
    organizationNumber: '123123121',
    companyName: 'LIV SCHJERVEN',
    owner: 'Liv Schjerven',
    organizationType: {
      code: 'ENK',
      description: 'Enkeltpersonforetak',
    },
    postalAddress: null,
    businessAddress: {
      streetNameAndNumber: 'Nordbylendet 18',
      postalCode: '3275',
      city: 'SVARSTAD',
      country: 'Norge',
      countryCode: 'NO',
      careOf: null,
    },
  },
  {
    organizationNumber: '123123122',
    companyName: 'ANDERS ASCHJEM',
    owner: 'Anders Aschjem',
    organizationType: {
      code: 'ENK',
      description: 'Enkeltpersonforetak',
    },
    postalAddress: null,
    businessAddress: {
      streetNameAndNumber: 'Lågendalsveien 4023',
      postalCode: '3275',
      city: 'SVARSTAD',
      country: 'Norge',
      countryCode: 'NO',
      careOf: null,
    },
  },
]

// Create lookup maps for both formats (with and without spaces)
export const mockOrganizations: Record<string, CompanyApiOrganization> = {}
mockOrgData.forEach((org) => {
  // Store with original format
  mockOrganizations[org.organizationNumber] = org
  // Also store without spaces for API calls
  const normalizedNumber = org.organizationNumber.replace(/\s/g, '')
  mockOrganizations[normalizedNumber] = org
})

// Mock suppliers data for testing
const mockSupplierData: {
  organizationNumber: string
  companyName: string
  supplierNumbers: number[]
}[] = [
  {
    organizationNumber: '123123121',
    companyName: 'LIV SCHJERVEN',
    supplierNumbers: [202133],
  },
  {
    organizationNumber: '123123122',
    companyName: 'ANDERS ASCHJEM',
    supplierNumbers: [202133, 202134],
  },
]

// Create lookup maps for both formats (with and without spaces)
export const mockSuppliers: Record<
  string,
  { organizationNumber: string; companyName: string; supplierNumbers: number[] }
> = {}
mockSupplierData.forEach((supplier) => {
  // Store with original format
  mockSuppliers[supplier.organizationNumber] = supplier
  // Also store without spaces for API calls
  const normalizedNumber = supplier.organizationNumber.replace(/\s/g, '')
  mockSuppliers[normalizedNumber] = supplier
})

/**
 * Check if an organization number should use mock data
 */
export const isMockOrganization = (orgNumber: string): boolean => {
  return orgNumber in mockOrganizations
}

/**
 * Get mock organization data
 */
export const getMockOrganization = (orgNumber: string): CompanyApiOrganization | null => {
  return mockOrganizations[orgNumber] ?? null
}

/**
 * Get mock suppliers data
 */
export const getMockSuppliers = (
  orgNumber: string,
): { organizationNumber: string; companyName: string; supplierNumbers: number[] } | null => {
  return mockSuppliers[orgNumber] ?? null
}
